// @flow

import React from 'react';
import cx from 'classnames';

import styles from './SupportingText.module.css';

type SupportingTextProps = {
  children: React.ReactNode,
  additionalClassnames?: string
};

const SupportingText = ({
  children,
  additionalClassnames,
  ...props
}: SupportingTextProps) => (
  <div
    aria-live='polite'
    className={cx(styles.supportingText, additionalClassnames)}
    {...props}>
    {children}
  </div>
);

export default SupportingText;
